import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@6.0.11/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checkMarkThin",
  "use": "checkMarkThin-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checkMarkThin\">\n\t<circle cx=\"18.0002\" cy=\"17.9999\" r=\"17.2692\" stroke=\"currentColor\" />\n\t<rect width=\"17.1346\" height=\"17.1346\" transform=\"translate(9.11572 9.11548)\" fill=\"none\" />\n\t<path d=\"M12.4043 18.6707L16.9287 22.5577L23.8274 13.6731\" stroke=\"currentColor\" stroke-linecap=\"square\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol